<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-bar-chart text-primary mr-2"></i>
                   Búsquedas Contable
                </h4>
            </b-col>
        </b-row>


    </div>
</template>

<script>
    import Spinner from 'vue-simple-spinner';
    import moment from 'moment'

    export default {
        name: "SearchTable",
        components: {
            Spinner
        },
        props: {
          tableData: {
            type: Array,
            required: true
          },
        },
        data() {
            return {
                topMenu: [],
                loading: false
            }
        },
        created() {
            this.$eventHub.$emit('captureMenu', this.topMenu);
          if (this.tableData) {
            this.getFieldList(this.tableData);
          }
        },
        mounted() {

        },
        methods: {
          async getFieldList(data) {
          },
        },
        watch: {

        }
    }
</script>

<style lang="scss">
    .header {
        background-color: #03A17C;
    }

    .total {
        background-color: goldenrod;
    }

    .subtotal {
        background-color: lightgoldenrodyellow;
    }

    .pair {
        background-color: #63e2c6;
    }

    .odd {
        background-color: white;
    }

    .pair .subtotal {
        background-color: rgb(254, 229, 157);
    }

    .accounting-table-container {
        overflow: scroll;
        height: 550px;
    }

    table.accounting-table {
        border-collapse: collapse;
        border: 1px solid black;

        th, td {
            border: 1px solid black;
            padding: 0.25rem;
        }
    }
</style>
